<template>
  <div class="img-box">
    <a :href="item.url" target="_blank"  v-for="(item, index) in dataLst" :key="index">
      <img :src="item.img" :alt="item.title" />
    </a>
  </div>
</template>

<script>
export default {
  name: "CooperateBox",
  data(){
    return {
      dataLst:[]
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    async getData(){
      await this.$http({
        method: "post",
        url: "getFriendList",
      }).then((res) => {
        if (res && res.data && res.data.list) {
          this.dataLst = res.data.list;
        }
        this.$emit('change-show',this.dataLst.length > 0)
      });
    }
  }
};
</script>

<style>
</style>
